import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { PartialPayment } from './sales-invoices-state/sales-invoices.model';

@Injectable({
  providedIn: 'root'
})
export class SalesInvoicesService {

  private _apiUrl = environment.apiUrl;
  private _httpClient = inject(HttpClient);

  createSalesInvoice(body: any) {
    return this._httpClient.post(`${this._apiUrl}/v1/sales-invoices/create-sales-invoice`, body);
  }
  getAllInvoices(startDate: string, endDate: string) {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-invoices/get-all-sales-invoices`, {
      params: {
        startDate,
        endDate,
      },
    });
  }

  getSalesProductComponents(_id: string) {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-shipping-instructions/get-sales-shipping-components-by-parent-id/${_id}`);
  }

  getFormData(_id: string) {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-invoices/get-form-data/${_id}`);
  }

  getAvailableSSIs() {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-invoices/get-availlable-ssi-references`);
  }

  getBanks() {
    return this._httpClient.get(`${this._apiUrl}/v1/banks/get-all-banks`);
  }

  createPayment(body: any, invoiceId: string) {
    return this._httpClient.post(`${this._apiUrl}/v1/sales-invoices/add-payment/${invoiceId}`, body);
  }

  createPdf(_id: string) {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-invoices/pdf-si/${_id}`,
      { responseType: 'blob' }
    );
  }
  updateSalesInvoice(id: string, md5Checksum: string, body: any) {
    return this._httpClient.post(`${this._apiUrl}/v1/sales-invoices/update-sales-invoice/${id}/${md5Checksum}`, body);
  }

  deleteSalesInvoice(_id: string) {
    return this._httpClient.delete(`${this._apiUrl}/v1/sales-invoices/delete-sales-invoice/${_id}`);
  }

  exportSalesInvoices(startDate: string, endDate: string) {
    return this._httpClient.get(`${this._apiUrl}/v1/sales-invoices/export-sales-invoices`, {
      params: { startDate, endDate },
      responseType: 'blob',
      observe: 'response',
    });
  }

  deletePayment(invoiceId: string, payment: PartialPayment) {
    return this._httpClient.delete(`${this._apiUrl}/v1/sales-invoices/delete-payment/${invoiceId}`, { body: payment },
    );
  }
}
